import { Dialog, DialogTitle } from '../../../../components/ui/dialog'
import ReviewStars from './review-stars'
import { ReviewAttribution } from './review-attribution'
import { displayTitle } from '../../helpers/utils'
import { Home } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../../components/ui/tooltip'
import { useReviewsConfig } from '../../providers'
import ResponsiveDialogContent from '../../../../components/ResponsiveDialogContent'
import { useReviewsCss } from '../../hooks/useReviewsCss'
import { ReviewPropertyLink } from './review-property-link'

export function ReviewDetailsModal() {
  const options = useReviewsConfig()
  const cssString = useReviewsCss()

  if (!options.detailReview) return null

  const review = options.detailReview
  const title = displayTitle(review)
  const showProperty = Boolean(options.showPropertyName && review.property_name)
  // #1692: same rule as the card — the property name carries the link, the
  // title only when the property line is hidden.
  const linkTitle = Boolean(options.linkToProperty) && !showProperty

  return (
    <Dialog open={!!review} onOpenChange={() => options.setDetailReview(null)}>
      <ResponsiveDialogContent
          className={`homerunner-review-details-modal ${options.resolvedTheme === 'dark' ? 'dark' : ''}`}
          elevateDom
          cssString={cssString}>
          <DialogTitle id='review-details-modal-title' className="homerunner-review-details-modal-title">Review Details</DialogTitle>
        <div className="homerunner-review-details-modal-content flex items-center justify-between gap-3 mb-2">
          <div className="homerunner-review-details-modal-header-left flex min-w-0 flex-1">
            <ReviewAttribution review={review} />
          </div>
          {!options.hideRating && (
            <div className="homerunner-review-details-modal-rating flex items-center gap-1 ml-4">
              <div className="homerunner-review-details-modal-stars">
                <ReviewStars rating={review.rating} starClass="w-4 h-4" />
              </div>
            </div>
          )}
        </div>
        {showProperty && (
          <div className="homerunner-review-details-modal-property flex items-center gap-2 mb-2 text-base font-medium text-foreground">
            <Home className="homerunner-review-details-modal-property-icon inline w-5 h-5 mr-1" />
            <span className="homerunner-review-details-modal-property-label">
              Stayed at
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <span className="homerunner-review-details-modal-property-name font-bold underline inline-block align-bottom ml-1 cursor-pointer text-primary">
                      {options.linkToProperty ? <ReviewPropertyLink review={review} className="homerunner-review-property-link">{review.property_name}</ReviewPropertyLink> : review.property_name}
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>
                    {review.property_name}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </span>
          </div>
        )}
        {title && (
          <span className="homerunner-review-details-modal-title-text font-bold mb-2 block text-foreground">
            {linkTitle ? <ReviewPropertyLink review={review} className="homerunner-review-title-link">{title}</ReviewPropertyLink> : title}
          </span>
        )}
        <div className="homerunner-review-details-modal-feedback mb-2 text-lg text-foreground">{review.content}</div>
        </ResponsiveDialogContent>
    </Dialog>
  )
}
